export enum LoginHintSecurityMethodTypes {
    PLAIN_JSON = 'PLAIN JSON',
    SIGNED_JWT = 'SIGNED JWT',
    JWT_ENCRYPTED = 'JWT ENCRYPTED'
}